module.exports = __webpack_public_path__ + "img/1518732802.12a48bf2.jpg";